import {
  useQueryClient,
  type InvalidateQueryFilters,
} from '@tanstack/react-query';

import { sandboxQueryKey } from '@/api/queryKeys';
import { useSandboxContext } from '@/providers/SandboxProvider';

export const useInvalidateAppQuery = () => {
  const queryClient = useQueryClient();
  const { gameCode, selectedSandbox } = useSandboxContext();

  return ({ queryKey, ...filters }: InvalidateQueryFilters) =>
    Promise.all([
      // `publish_status` lives on the unscoped sandbox detail, outside the
      // [gameCode, sandboxCode] subtree — any scoped mutation can move it.
      queryClient.invalidateQueries({
        ...filters,
        queryKey: sandboxQueryKey.current,
      }),
      queryClient.invalidateQueries({
        ...filters,
        queryKey: queryKey
          ? [gameCode, selectedSandbox, ...queryKey]
          : undefined,
      }),
    ]);
};
